import { typedStorage, type UserInfo } from "@/utils/storage"

const getParamsFromSearchAndHash = () => {
  const params = new URLSearchParams(window.location.search)
  const queryStartIndex = window.location.hash.indexOf("?")

  if (queryStartIndex !== -1) {
    const hashQuery = window.location.hash.slice(queryStartIndex + 1)
    const hashParams = new URLSearchParams(hashQuery)
    hashParams.forEach((value, key) => {
      if (!params.has(key)) {
        params.set(key, value)
      }
    })
  }

  return params
}

/**
 * 开发环境 Mock 用户信息组件
 * 仅在开发环境自动设置 mock 用户信息到缓存中
 * 在非开发环境，如果 URL 中带有 uid 和 accesstoken 参数，则使用这些参数设置用户信息
 *
 * 注意：此逻辑在组件函数体顶部同步执行，确保在 API 请求之前设置缓存
 */
export default function DevMockUser() {
  // 同步执行，确保在组件渲染和 API 请求之前设置缓存
  if (typeof window !== "undefined") {
    const mockUserSwitch = import.meta.env.VITE_DEV_MOCK_USER_ENABLED
    const shouldMockUser = mockUserSwitch ? mockUserSwitch === "true" : import.meta.env.DEV

    if (shouldMockUser) {
      // uid: '100341'
      const uid = import.meta.env.VITE_DEV_AUTH_UID as string
      const token = import.meta.env.VITE_DEV_AUTH_TOKEN as string
      // 开发环境：设置 Mock 用户信息
      const mockUserInfo: UserInfo = {
        avatarurl: "https://via.placeholder.com/100",
        uid,
        nickname: "faker",
        duid: uid,
        accesstoken: token,
      }

      // 设置到缓存中
      typedStorage.setUserInfo(mockUserInfo)
      console.log("[DevMockUser] Mock 用户信息已设置:", mockUserInfo)
    } else {
      // 非开发环境：从 URL 参数中获取 uid 和 accesstoken
      const searchParams = getParamsFromSearchAndHash()

      // 打印所有 URL 参数
      const allParams = Object.fromEntries(searchParams.entries())
      console.log("[DevMockUser] URL 所有参数:", allParams)

      const uid = searchParams.get("uid")
      const accesstoken = searchParams.get("accesstoken")

      // 如果 URL 中同时存在 uid 和 accesstoken，则设置到缓存中
      if (uid && accesstoken) {
        const userInfo: UserInfo = {
          avatarurl: "",
          uid: uid,
          nickname: "",
          duid: "",
          accesstoken: accesstoken,
        }

        // 设置到缓存中
        typedStorage.setUserInfo(userInfo)
        console.log("[DevMockUser] 从 URL 参数设置用户信息:", userInfo)
      }
    }
  }

  // 此组件不渲染任何内容
  return null
}
